import { api } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function usePeople() {
  const queryKey = ['people'];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      const json = [
        {
          $graphLookup: {
            from: 'groups',
            startWith: '$groupCodes',
            connectFromField: 'parentCodes',
            connectToField: 'code',
            as: 'groupAncestorCodes',
          },
        },
        {
          $project: {
            code: true,
            picture: true,
            forenames: true,
            surname: true,
            collarNumber: true,
            radioSsi: true,
            lastPollTime: true,
            rfidCards: true,
            role: true,
            homeStation: true,
            leavingDate: true,
            assignments: true,
            emailAddress: true,
            groupAncestorCodes: {
              $map: {
                input: '$groupAncestorCodes',
                as: 'group',
                in: '$$group.code',
              },
            },
            searchString: {
              $toLower: {
                $concat: [
                  { $ifNull: ['$forenames', ''] },
                  ' ',
                  { $ifNull: ['$surname', ''] },
                  '+',
                  { $ifNull: ['$code', ''] },
                  '+',
                  { $ifNull: ['$collarNumber', ''] },
                  '+',
                  { $ifNull: ['$radioSsi', ''] },
                  '+',
                  { $ifNull: ['$emailAddress', ''] },
                  '+',
                  {
                    $reduce: {
                      input: { $ifNull: ['$rfidCards', []] },
                      initialValue: '',
                      in: {
                        $concat: [
                          { $ifNull: ['$$value', ''] },
                          '+',
                          { $ifNull: ['$$this.reference', ''] },
                        ],
                      },
                    },
                  },
                ],
              },
            },
          },
        },
      ];

      log('Read', 'People');

      return api.post('pipeline/people', { json, signal }).json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
